import HelpController from './help-modal.controller';
import template from './help-modal.html';

class InfoWidgetController {
    constructor($uibModal) {
        this._$uibModal = $uibModal;
    }

    openHelpWindow() {
        this._$uibModal.open({
            animation: false,
            template: template,
            controllerAs: '$ctrl',
            size: 'lg',
            resolve: {
                type: () => {
                    return this.topic;
                }
            },
            controller: HelpController,
        });
    }
}

InfoWidgetController.$inject = ['$uibModal', ];

export default InfoWidgetController;



// WEBPACK FOOTER //
// ./client/app/common/info-widget/info-widget.controller.js